import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import {
  UNIFIED_FEED_DOMAIN_SERVICE,
  TOI_LIVE_DOMAIN,
  TOI_IMAGE_DOMAIN,
} from 'constants/index';
import Cookie from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import { msToTime } from 'utils/common';
import { timeStringToMilliseconds } from 'routes/games/layouts/utils';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
// import Link from 'components/Link';
import initGame from './Game';
import GameOverlay from '../GameOverlay/GameOverlay';
//import LeaderBoard from '../LeaderBoard/LeaderBoard';
//import Streak from '../Streak/Streak';
// import PracticeCard from '../PracticeCard/PracticeCard';
// import GameCard from '../GameCard/GameCard';
import s from './CrosswordGame.scss';
import breadcrumbs from '../../../GameBreadcrumbsHelper';
import BreadCrumb from '../../../../../components_v2/common/BreadCrumb/BreadCrumb';
import ShareButton from '../ShareButton/ShareButton';
import {
  loadSyncUp,
  loadCrosswordStateFetch,
  loadCrosswordStateSave,
} from '../../../redux';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import GameCardListing from '../GameCardListing/GameCardListing';
import GamesBudgetCta from '../GamesBudgetCta/GamesBudgetCta';
import MoreOnGames from '../../common/MoreOnGames/MoreOnGames';
//import NewGameTimer from '../NewGameTimer/NewGameTimer';

const CrosswordGame = props => {
  const {
    isMobile,
    isPrime,
    isFrmapp,
    puzzleAPI,
    userData,
    todaysGame,
    isToday,
    handleGameCallback,
    type,
    gameApiConfigData,
    stateData,
    buttonClicked,
    showbudgetLinkIdConfig,
    gameSolutionData,
    viewSolution,
    showCongratulationsData,
  } = props;
  const apiConfigData =
    type === 'crossword'
      ? gameApiConfigData?.crossword
      : gameApiConfigData?.mini_crossword;
  const commonTranslations = _get(
    props,
    'gamesconfigData.translations.commonTranslations',
    {},
  );
  const gameSpecificTranslations = _get(
    props,
    'gamesconfigData.translations.gameSpecificTranslations.crossword',
    {},
  );
  const [hasSynced, setHasSynced] = useState(false);
  const userDataRef = useRef(userData);
  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [showLoader, setLoader] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [showCongrate, setCongrate] = useState(false);
  const [showCongrateSataus, setCongrateSataus] = useState(false);
  const [failedAPI, setFailedAPI] = useState('');
  // const gamesListingData =
  //   props.gameslisting && props.gameslisting ? props.gameslisting : {};
  const gamesMetaWidgetData = props.gamesmetawidget;
  const gameId = puzzleAPI && puzzleAPI.gameId ? puzzleAPI.gameId : '';
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';
  let playAgainCheckTemp = false;
  if (typeof localStorage !== 'undefined') {
    let toigames = localStorage.getItem('toigames');
    toigames = toigames ? JSON.parse(toigames) : {};
    playAgainCheckTemp =
      toigames.playagain && toigames.playagain.includes(gameId);
  }
  const [playAgainCheck, setPlayAgainCheck] = useState(playAgainCheckTemp);

  const fireGa = (gaType, gaCategory = '', isEventShown = false, gaLabel) => {
    let gameType = type;
    if (type === 'mini-crossword') {
      gameType = 'mini_crossword';
    }
    const gaData = {
      event: isEventShown ? 'user_shown_games' : 'user_click_games',
      type: gaType,
      page_template: 'gameplay',
      section: 'games',
      subsection: gameType,
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: 'N/A',
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (gaCategory) {
      gaData.category = gaCategory;
    }
    if (gaLabel) {
      gaData.label = gaLabel;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper(
      'grx',
      'track',
      isEventShown ? 'user_shown_games' : 'user_click_games',
      gaData,
    );
  };

  const fireGaGameScreen = (gaLabelText, score = '', gaType) => {
    let gameType = type;
    if (type === 'mini-crossword') {
      gameType = 'mini_crossword';
    }
    const gaData = {
      event: 'user_shown_games',
      type: gaType || 'gameplay_screen',
      label: gaLabelText,
      page_template: 'gameplay',
      section: 'games',
      subsection: gameType,
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: 'N/A',
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (score) {
      gaData.score = score;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const overlayCall = popuptype => {
    setShowOverlay(true);
    setPopUpType(popuptype);
  };

  const hardPause = () => {
    if (typeof handleGameCallback === 'function') handleGameCallback();
  };
  let gameType = type;
  if (type === 'mini-crossword') {
    gameType = 'mini_crossword';
  }
  const showBudgetTheme =
    !!gameType &&
    gameType !== '' &&
    gameType === 'crossword' &&
    !!showbudgetLinkIdConfig &&
    showbudgetLinkIdConfig !== '' &&
    !!gameId &&
    showbudgetLinkIdConfig === gameId;
  // useEffect(
  //   () => {
  //     userDataRef.current = userData;
  //   },
  //   [userData],
  // );

  useEffect(
    () => {
      let stateGame;
      if (gameType && stateData) {
        stateGame =
          gameType === 'crossword'
            ? stateData.stateCrossword
            : stateData.stateMiniCrossword;
      }

      if (stateGame && buttonClicked !== 'start_over') {
        try {
          if (typeof localStorage !== 'undefined') {
            const lsVal = JSON.stringify({
              //timestamp: Date.now(),
              state: stateGame.state,
              penaltyPairs: stateGame.penaltyPairs,
              completionTimeInMillis: stateGame.completionTimeInMillis,
              penaltyTimeInMillis: stateGame.penaltyTimeInMillis,
              lastFocussedCell: stateGame.lastFocussedCell,
            });
            if (lsVal !== '{}') {
              window.localStorage.setItem(`tilstate:${gameId}`, lsVal);
              if (window && window.crossword) {
                window.crossword.restoreState();
              }
            }
          }
        } catch (err) {
          console.log('game error>>', err);
        }
      }
    },
    [stateData, buttonClicked],
  );

  const howtoPlaycheck = popuptype => {
    try {
      if (typeof localStorage !== 'undefined') {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const howtoplay = parsedValue ? parsedValue.howtoplay : '';
        if (!howtoplay) {
          setShowOverlay(true);
          setPopUpType(popuptype);
          if (window && window.crossword) {
            window.crossword.pause = true;
          }
        }
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  const clearLocalStorage = key => {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  const clearPlayAgain = () => {
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      let playagainArray = toigames.playagain && toigames.playagain.split(',');
      if (playagainArray && playagainArray.includes(gameId)) {
        playagainArray = playagainArray.filter(id => id !== gameId);
        toigames.playagain = playagainArray.join(',');
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
  };

  const gameSyncCall = () => {
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const params = {
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData && userData.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  const gameStateFetchCall = state => {
    if (
      typeof props.loadCrosswordStateFetch === 'function' &&
      userData &&
      userData.isLoggedIn &&
      todaysGame &&
      !playAgainCheck
    ) {
      const params = {
        gameId,
        gameType,
        grxId,
        ssoId,
        state,
      };
      props.loadCrosswordStateFetch(params);
    }
  };

  const gameStateSaveCall = () => {
    if (
      typeof props.loadCrosswordStateSave === 'function' &&
      userData &&
      userData.isLoggedIn &&
      todaysGame &&
      !playAgainCheck
    ) {
      const lsVal = window.localStorage.getItem(`tilstate:${gameId}`);
      if (lsVal) {
        try {
          const gridSize =
            type === 'crossword'
              ? { row: 10, column: 10 }
              : { row: 5, column: 5 };
          const decoded = JSON.parse(lsVal);
          const params = {
            gameId,
            gameType,
            grxId,
            ssoId,
            state: decoded.state,
            lastFocussedCell: decoded.lastFocussedCell,
            penaltyPairs: decoded.penaltyPairs,
            penaltyTimeInMillis: decoded.penaltyTimeInMillis,
            completionTimeInMillis: decoded.completionTimeInMillis,
            gridSize,
          };
          props.loadCrosswordStateSave(params);
        } catch (e) {
          console.log('game error>>', e);
        }
      }
    }
  };

  // useEffect(
  //   () => {
  //     if (typeof props.loadCrosswordStateFetch === 'function') {
  //       userDataRef.current = userData;
  //       if (userData && userData.isLoggedIn && !hasStateData) {
  //         gameStateFetchCall();
  //         sethasStateData(true);
  //       }
  //     }
  //   },
  //   [userData, hasStateData],
  // );

  const gameSubmitCall = (timeTaken, timePenalty, state) => {
    const tempPlayAgainCheck = playAgainCheck ? '&playAgain=true' : '';
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/submit/game?pc=toi&pfm=web&fv=1250&gameId=${
      puzzleAPI.gameId
    }&gameType=${gameType}${tempPlayAgainCheck}`;
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }

    let gameStateData = {};
    if (state) {
      const stateParts = state.split('|');
      const gridState = stateParts[0] || '';

      const lsVal = window?.localStorage?.getItem(`tilstate:${gameId}`);
      if (lsVal) {
        try {
          const lsData = JSON.parse(lsVal);
          gameStateData = {
            state: gridState,
            lastFocussedCell: lsData.lastFocussedCell,
            penaltyPairs: lsData.penaltyPairs,
            completionTimeInMillis: lsData.completionTimeInMillis,
            penaltyTimeInMillis: lsData.penaltyTimeInMillis,
          };
        } catch (e) {
          console.log('Error parsing localStorage for additional data', e);
          gameStateData = { state: gridState };
        }
      } else {
        gameStateData = { state: gridState };
      }
    } else {
      const lsVal = window?.localStorage?.getItem(`tilstate:${gameId}`);
      if (lsVal) {
        try {
          gameStateData = JSON.parse(lsVal);
        } catch (e) {
          console.log('Error parsing localStorage', e);
        }
      }
    }

    const gridSize =
      type === 'crossword' ? { row: 10, column: 10 } : { row: 5, column: 5 };

    const postData = {
      penaltyTimeInMillis: timePenalty * 1000,
      completionTimeInMillis: timeTaken * 1000,
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      penaltyItem: {
        hints: 0,
        emptyCells: 0,
        wrongInput: 0,
      },
      // Add game state parameters
      state: gameStateData.state,
      lastFocussedCell: gameStateData.lastFocussedCell,
      penaltyPairs: gameStateData.penaltyPairs,
      gridSize,
    };
    const grxIdLatest = Cookie.get('_grx') || '';
    const ssoIdLatest = Cookie.get('ssoid') || '';
    grxId = grxId || grxIdLatest;
    ssoId = ssoId || ssoIdLatest;
    setLoader(true);
    makeRequest
      .post(url, postData, { headers: { grxId, ssoId } })
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          setPlayAgainCheck(false);
          const gameCongratulationsData = data.data.items.filter(
            item => item.tn === 'gameCongratulationsData',
          )[0];
          if (
            gameCongratulationsData &&
            gameCongratulationsData.gameCongratulationsData
          ) {
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData.gameCongratulationsData,
              loggedInResult,
            });
            const achievementCards =
              gameCongratulationsData?.gameCongratulationsData
                ?.achievementCards;
            const tempGameScore =
              Array.isArray(achievementCards) &&
              achievementCards.length > 0 &&
              typeof achievementCards[0]?.primaryText === 'string' &&
              achievementCards[0].primaryText.trim() !== ''
                ? timeStringToMilliseconds(achievementCards[0].primaryText)
                : 'N/A';
            fireGaGameScreen('submit_game', tempGameScore, 'results_score');
          }
          setCongrate(true);
          setLoader(false);
        }
        setLoader(false);
        clearPlayAgain(gameId);
        return false;
      })
      .catch(err => {
        console.error(err);
        setFailedAPI('submit_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
    return false;
  };

  const gameAPICall = (callCase, timeTaken, timePenalty, state) => {
    if (callCase === 'submit') {
      gameStateSaveCall();
      gameSubmitCall(timeTaken, timePenalty, state);
      clearLocalStorage(`tilstate:${gameId}`);
    } else if (callCase === 'saveStateCall') {
      gameStateSaveCall();
    } else if (callCase === 'fetchStateCall') {
      gameStateFetchCall(state);
    }
  };

  const handleViewSolution = () => {
    setLoader(true);
    if (!viewSolution || !gameSolutionData) {
      return;
    }

    try {
      // 1. Clear old crossword
      const crosswordContainer = document.getElementById('til-embedder');
      if (crosswordContainer) {
        crosswordContainer.innerHTML = '';
      }
      if (window?.crossword) {
        window.crossword = null;
      }

      initGame({
        isMobile,
        isPrime,
        isFrmapp,
        overlayCall,
        puzzleAPI,
        gameAPICall,
        showCongrate,
        todaysGame,
        hardPause,
        type,
        apiConfigData,
        fireGa,
        viewSolution,
      });

      // Wait for the game to be initialized and then apply the solution
      const checkGameInitialized = () => {
        // Safety check for window and crossword object
        if (!window?.crossword) {
          // Game not yet initialized, check again in 100ms
          setTimeout(checkGameInitialized, 100);
          return;
        }

        const { crossword } = window;

        // Validate crossword object has required properties
        if (!crossword.prefix || !crossword.grid || !crossword.colorScheme) {
          setTimeout(checkGameInitialized, 100);
          return;
        }

        // Check if the game is fully initialized by looking for the grid
        const gridElement = document.getElementById(`${crossword.prefix}-grid`);
        if (!gridElement) {
          // Grid not yet present, check again in 100ms
          setTimeout(checkGameInitialized, 100);
          return;
        }

        // Apply the user's input state from gameSolutionData
        const userInputState = gameSolutionData?.stateCrossword?.state;
        if (!userInputState) {
          setLoader(false);
          return;
        }
        try {
          if (typeof crossword.parseState === 'function') {
            crossword.parseState(userInputState);
          }
          // Update clue states to show as solved
          if (
            crossword.allClueIndices &&
            Array.isArray(crossword.allClueIndices)
          ) {
            crossword.allClueIndices.forEach(ci => {
              if (typeof crossword.updateClueState === 'function') {
                crossword.updateClueState(ci, false, 'solved', true);
              }
            });
          }
          const { grid, colorScheme, gridHeight, gridWidth } = crossword;
          const userInputMap = {};

          if (!gridHeight || !gridWidth || !grid) {
            setLoader(false);
            return;
          }

          // Store the user's original input before revealing
          for (let row = 0; row < gridHeight; row += 1) {
            for (let col = 0; col < gridWidth; col += 1) {
              const gridCell = grid[row]?.[col];
              userInputMap[`${row}-${col}`] =
                gridCell.currLetter?.toUpperCase()?.trim() || '';
            }
          }

          // Now reveal all cells to show correct answers
          if (typeof crossword.revealAll === 'function') {
            crossword.revealAll();
          }

          // Then apply colors to all cells based on user input vs correct answers
          for (let row = 0; row < gridHeight; row += 1) {
            for (let col = 0; col < gridWidth; col += 1) {
              const gridCell = grid[row]?.[col];

              // Set cell background to white like in submit
              if (gridCell.cellRect?.style) {
                gridCell.cellRect.style.fill = '#FFFFFF';
              }

              // Get the user's original input for this cell
              const userInput = userInputMap[`${row}-${col}`];
              const correctAnswer = gridCell.solution?.toUpperCase();

              // Apply color based on user input vs correct answer
              if (gridCell.cellText?.style) {
                if (userInput && userInput !== '0' && userInput !== '') {
                  // User had input - check if it was correct
                  if (userInput === correctAnswer) {
                    gridCell.cellText.style.fill = colorScheme.correctEntry; // Green for correct
                  } else {
                    gridCell.cellText.style.fill = colorScheme.errorEntry; // Red for incorrect
                  }
                } else {
                  // No user input - show solution in blue
                  gridCell.cellText.style.fill = '#1E1D4B';
                }
              }
            }
          }

          // Set a flag to prevent color changes from slider interactions
          crossword.solutionViewActive = true;

          // Override any other methods that might change colors
          const originalUpdateDisplayAndGetState =
            crossword.updateDisplayAndGetState;
          // eslint-disable-next-line func-names
          crossword.updateDisplayAndGetState = function(
            notifyIfComplete = true,
          ) {
            // Call original but then restore our solution colors
            const result = originalUpdateDisplayAndGetState.call(
              this,
              notifyIfComplete,
            );

            // Restore solution colors if they were changed
            if (this.solutionViewActive) {
              for (let row = 0; row < this.gridHeight; row += 1) {
                for (let col = 0; col < this.gridWidth; col += 1) {
                  const gridCell = this.grid[row]?.[col];

                  const userInput = userInputMap[`${row}-${col}`];
                  const correctAnswer = gridCell.solution?.toUpperCase();

                  if (gridCell.cellText?.style) {
                    if (userInput && userInput !== '0' && userInput !== '') {
                      if (userInput === correctAnswer) {
                        gridCell.cellText.style.fill = this.colorScheme.correctEntry;
                      } else {
                        gridCell.cellText.style.fill = this.colorScheme.errorEntry;
                      }
                    } else {
                      gridCell.cellText.style.fill = '#1E1D4B';
                    }
                  }
                }
              }
            }

            return result;
          };

          // Disable editing and show as completed
          crossword.overlayCall = () => {};
          crossword.hardPause = () => {};

          if (crossword.svg?.style) {
            crossword.svg.style.pointerEvents = 'none';
          }

          // Make all grid inputs readonly
          const gridInputs = document.querySelectorAll(
            '.til-grid-input.til-cell-text',
          );
          gridInputs.forEach(input => {
            if (input) {
              input.readOnly = true;
            }
          });

          // Try to remove timer and controls elements if they exist
          const timeblock = document.getElementById(
            `${crossword.prefix}-timeBlock`,
          );
          const controlsElement = document.getElementById(
            `${crossword.prefix}-controls-etc`,
          );

          // Remove elements if they exist
          if (timeblock?.parentNode) {
            timeblock.parentNode.removeChild(timeblock);
          }
          if (controlsElement?.parentNode) {
            controlsElement.parentNode.removeChild(controlsElement);
          }

          // Stop timer if it exists
          if (crossword.stopTimeCounter) {
            clearInterval(crossword.stopTimeCounter);
          }

          // Update and save state
          if (typeof crossword.updateAndSaveState === 'function') {
            crossword.updateAndSaveState(false);
          }

          setLoader(false);
          fireGaGameScreen('view_solution');
        } catch (error) {
          console.error('Error applying solution state:', error);
          setLoader(false);
        }
      };
      checkGameInitialized();

      // After crossword initialization showing clues
      setTimeout(() => {
        const clueSlider = document.querySelector('.til-curr-clue');
        if (clueSlider) {
          clueSlider.style.display = '';
        }
        if (
          window.crossword &&
          typeof window.crossword.cnavToInner === 'function'
        ) {
          const firstClue =
            window.crossword.allClueIndices &&
            window.crossword.allClueIndices[0];
          if (firstClue) {
            window.crossword.cnavToInner(firstClue, false);
          }
        }
      }, 100);
    } catch (error) {
      console.error('error inside game js >>', error);
      setLoader(false);
    }
  };

  const getStatusCall = () => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?pc=toi&pfm=web&gameId=${gameId}&gameType=${gameType}`;
    const requestParams = {
      params: {},
      headers: {
        grxId,
        ssoId,
      },
    };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          if (data && data.data && data.data.hasPlayed && !playAgainCheck) {
            const gameCongratulationsData = data.data.items.filter(
              item => item.tn === 'gameCongratulationsData',
            )[0];
            if (
              gameCongratulationsData &&
              gameCongratulationsData.gameCongratulationsData
            ) {
              const loggedInResult = !!(grxId && ssoId);
              setResultData({
                ...gameCongratulationsData.gameCongratulationsData,
                loggedInResult,
              });
              const achievementCards =
                gameCongratulationsData?.gameCongratulationsData
                  ?.achievementCards;
              const tempGameScore =
                Array.isArray(achievementCards) &&
                achievementCards.length > 0 &&
                typeof achievementCards[0]?.primaryText === 'string' &&
                achievementCards[0].primaryText.trim() !== ''
                  ? timeStringToMilliseconds(achievementCards[0].primaryText)
                  : 'N/A';
              fireGaGameScreen('view_results', tempGameScore, 'results_score');
            }
            setLoader(false);
            setCongrateSataus(true);
            setCongrate(true);
            clearLocalStorage(`tilstate:${gameId}`);
          } else {
            try {
              if (playAgainCheck) {
                if (data && data.data && data.data.hasPlayed) {
                  const gameCongratulationsData = data.data.items.filter(
                    item => item.tn === 'gameCongratulationsData',
                  )[0];
                  if (
                    gameCongratulationsData &&
                    gameCongratulationsData.gameCongratulationsData
                  ) {
                    const loggedInResult = !!(grxId && ssoId);
                    setResultData({
                      ...gameCongratulationsData.gameCongratulationsData,
                      loggedInResult,
                    });
                  }
                }
              }
              initGame({
                isMobile,
                isPrime,
                isFrmapp,
                overlayCall,
                puzzleAPI,
                gameAPICall,
                showCongrate,
                todaysGame,
                hardPause,
                type,
                apiConfigData,
                fireGa,
                viewSolution,
              });
              fireGaGameScreen(buttonClicked);
            } catch (error) {
              console.error('error inside game js >>', error);
            }
            setLoader(false);
          }
          return false;
        }
        try {
          initGame({
            isMobile,
            isPrime,
            isFrmapp,
            overlayCall,
            puzzleAPI,
            gameAPICall,
            showCongrate,
            todaysGame,
            hardPause,
            type,
            apiConfigData,
            fireGa,
            viewSolution,
          });
          fireGaGameScreen(buttonClicked);
        } catch (error) {
          console.error('error inside game js >>', error);
        }
        setLoader(false);
        return false;
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('status_api');
        overlayCall('errorPopUp');
        setLoader(false);
        fireGaGameScreen(buttonClicked);
      });
    return false;
  };
  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  // const playAgain = () => {
  //   if (typeof localStorage !== 'undefined') {
  //     let toigames = localStorage.getItem('toigames');
  //     toigames = toigames ? JSON.parse(toigames) : {};
  //     if (!toigames.playagain || !toigames.playagain.includes(gameId)) {
  //       toigames.playagain = toigames.playagain
  //         ? `${toigames},${gameId}`
  //         : gameId;
  //       localStorage.setItem('toigames', JSON.stringify(toigames));
  //     }
  //     setCongrateSataus(false);
  //     setPlayAgainCheck(true);
  //     initGame({
  //       isMobile,
  //       isPrime,
  //       isFrmapp,
  //       overlayCall,
  //       puzzleAPI,
  //       gameAPICall,
  //       showCongrate,
  //       todaysGame,
  //       hardPause,
  //       type,
  //       apiConfigData,
  //       fireGa,
  //     });
  //     setLoader(false);
  //   }
  // };

  const scrollToGame = () => {
    const gameContainer = document?.getElementById('til-embedder');
    if (gameContainer) {
      gameContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  useEffect(() => {
    const handleBeforeUnload = event => {
      event.preventDefault();
      gameAPICall('saveStateCall', '', '');
      event.returnValue = ''; // Required for Chrome
      return ''; // Required for Firefox
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    scrollToGame();
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // const renderShareFeedbank = () => (
  //   <div className={s.shareFeedback}>
  //     <strong>Share Your Feeback</strong>
  //     <Link
  //       target="_blank"
  //       className={s.btnPrimary}
  //       data-newga=""
  //       to="https://docs.google.com/forms/d/e/1FAIpQLSd5hAk46tH9cOSN6WwbWiVXyr9LYCoyKPVkHpZdZbfi4Y3JCQ/viewform"
  //       title="feedback"
  //     >
  //       Submit Here
  //     </Link>
  //   </div>
  // );

  useEffect(() => {
    howtoPlaycheck('typeOne');
    if (viewSolution && gameSolutionData) {
      handleViewSolution();
    } else {
      getStatusCall();
    }
  }, []);

  let breadCrumbKey;
  if (isToday) {
    breadCrumbKey =
      gameType === 'mini_crossword' ? 'MiniCrosswordToday' : 'crosswordToday';
  } else {
    breadCrumbKey =
      gameType === 'mini_crossword'
        ? 'MiniCrosswordPractice'
        : 'crosswordPractice';
  }

  const breadCrumbData = breadcrumbs?.[breadCrumbKey] || [];

  return (
    <>
      <div
        className={`${showBudgetTheme ? s.BudgetTheme : ''} ${
          s.CrosswordGame
        } ${
          gameType === 'mini_crossword' || gameType === 'mini-crossword'
            ? s.miniCrosswordGame
            : ''
        } ${s.br16}`}
      >
        {showBudgetTheme &&
          !isMobile &&
          !viewSolution && <div className={s.budgetBg} />}
        {!viewSolution &&
          breadCrumbData &&
          !isMobile && (
            <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
          )}
        {showLoader && (
          <div className={s.loaderouter}>
            <LoaderSpinner />
          </div>
        )}
        {!showCongrate &&
          !viewSolution && (
            <div className={s.title}>
              {gamesMetaWidgetData &&
                gamesMetaWidgetData.metaInfo &&
                gamesMetaWidgetData.metaInfo.TemplateH1TopHeading &&
                gamesMetaWidgetData.metaInfo.TemplateH1TopHeading.value !==
                  '' && (
                  <>
                    {showBudgetTheme && (
                      <>
                        {isMobile ? (
                          <figure className={s.mwebTtitle}>
                            <img
                              src={`${TOI_IMAGE_DOMAIN}/photo/117675285.cms`}
                              alt="budget 2025 - 26"
                            />
                          </figure>
                        ) : (
                          <figure className={s.budgetWebTtitle}>
                            <img
                              src={`${TOI_IMAGE_DOMAIN}/photo/117675275.cms`}
                              alt="budget 2025 - 26"
                            />
                          </figure>
                        )}
                      </>
                    )}
                    {!showBudgetTheme && (
                      <h1>
                        {
                          gamesMetaWidgetData?.metaInfo?.TemplateH1TopHeading
                            ?.value
                        }
                      </h1>
                    )}
                  </>
                )}
              {isMobile ? (
                ''
              ) : (
                <ShareButton
                  // title={componentData.gameType}
                  url={`${TOI_LIVE_DOMAIN}/games/crossword/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                  gaCat="Crossword"
                  gaOnClick={() => {
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: 'share',
                      category: 'game',
                    });
                    analyticsWrapper('grx', 'track', 'user_click', {
                      event: 'user_click',
                      type: 'share',
                      category: 'game',
                    });
                  }}
                />
              )}
            </div>
          )}
        {showOverlay && (
          <GameOverlay
            commonTranslations={commonTranslations}
            gameSpecificTranslations={gameSpecificTranslations}
            popUpType={popUpType}
            gameOverlayCallback={gameOverlayCallback}
            gameType={
              gameType === 'mini-crossword' ? 'mini_crossword' : gameType
            }
            apiConfigData={apiConfigData}
            gameId={gameId}
            failedAPI={failedAPI}
          />
        )}
        {!showCongrateSataus && (
          <div
            id="til-embedder"
            className={`${s.helpbar} til-embedder ${
              gameType === 'mini_crossword' ? 'miniCrossword' : ''
            } `}
          >
            {!viewSolution && <LoaderSpinner />}
          </div>
        )}
        {!viewSolution &&
          resultData &&
          !playAgainCheck && (
            <>
              <CongratulationsNew
                resultData={resultData}
                gameId={gameId}
                showCongrate={showCongrate}
                playAgainCheck={playAgainCheck}
                buttonClicked={buttonClicked}
                type={type}
              />
              {showBudgetTheme && <GamesBudgetCta />}
            </>
          )}
        <div className={s.gameWrapper}>
          {/* <div className={s.gameLeftArea}> */}
          {/* {(!showCongrate || playAgainCheck) && renderShareFeedbank()} */}
          {/* {resultData &&
              playAgainCheck && (
                <div className={s.previousGame}>
                  <h2>Previous Game</h2>
                  <div className={s.previousGameWrap}>
                    <ul>
                      <li>
                        <div className={s.left}>Your completing time is</div>
                        <div className={s.time}>
                          {msToTime(resultData.completionTimeInMillis) || 'N/A'}
                        </div>
                      </li>
                      <li>
                        <div className={s.left}>
                          Penalty Time
                          <span>Due to reveal &amp; Incorrect answers*</span>
                        </div>
                        <div className={`${s.time} ${s.penaltyTime}`}>
                          {msToTime(resultData.penaltyTimeInMilliseconds) ||
                            'N/A'}
                        </div>
                      </li>
                    </ul> */}
          {/* <div className={s.playAgain}>
                      <button className={s.btnPrimary}>
                        Play Again <i className={s.againIcon} />
                      </button>
                    </div> */}
          {/* </div>
                </div>
              )}
          </div> */}
          {/* <div className={s.gameRightArea}>
            {(showCongrate || playAgainCheck) && (
              <>
                <LeaderBoard gameId={puzzleAPI.gameId} />
              </>
            )}
          </div> */}
          {!viewSolution &&
            isMobile &&
            (!showCongrate || playAgainCheck) && (
              <div
                className={s.keypad}
                id="til_crossword_keyboard"
                style={{ display: 'none' }}
              >
                <ul>
                  <li>
                    <button type="button">Q</button>
                    <button type="button">W</button>
                    <button type="button">E</button>
                    <button type="button">R</button>
                    <button type="button">T</button>
                    <button type="button">Y</button>
                    <button type="button">U</button>
                    <button type="button">I</button>
                    <button type="button">O</button>
                    <button type="button">P</button>
                  </li>
                  <li>
                    <button type="button">A</button>
                    <button type="button">S</button>
                    <button type="button">D</button>
                    <button type="button">F</button>
                    <button type="button">G</button>
                    <button type="button">H</button>
                    <button type="button">J</button>
                    <button type="button">K</button>
                    <button type="button">L</button>
                  </li>
                  <li>
                    <button type="submit" className={s.submit} value="submit">
                      submit
                    </button>
                    <button type="button">Z</button>
                    <button type="button">X</button>
                    <button type="button">C</button>
                    <button type="button">V</button>
                    <button type="button">B</button>
                    <button type="button">N</button>
                    <button type="button">M</button>
                    <button type="button" value="deleted">
                      <div className={s.erase}>
                        <i className={s.deleteIcon} />
                      </div>
                    </button>
                  </li>
                </ul>
              </div>
            )}
        </div>
        {!viewSolution &&
          showCongrate &&
          !playAgainCheck && (
            <div className={s.gameCardArea}>
              {/* {!showCongrateSataus && (
                    <div className={s.gamePoints}>
                      <ul>
                        <li>
                          Correctly filled cell
                          <div className={s.block}>A</div>
                        </li>
                        <li>
                          Incorrectly filled &amp; blank cell revealed
                          <div className={`${s.block} ${s.green}`}>A</div>
                        </li>
                      </ul>
                    </div>
                  )} */}
              <div className={s.gameWidget}>
                {/* <div className={s.practiceCard}>
                  <PracticeCard
                    gameType={gameType}
                    isLargeCard={!isMobile}
                    ga4Category="congratulations"
                    gameId={gameId}
                    isMobile={isMobile}
                  />
                </div> */}
                <MoreOnGames
                  gameType={gameType}
                  isMobile
                  forceLoadDataOnInit
                  isCogratulationsPage
                  cardProps={{ ga4Category: 'congratulations' }}
                  gameId={gameId}
                  moreOnGamesTitle="Explore More Games"
                />
                {/* <div className={s.gameCardList}>
                  <GameCardListing
                    cardsIncluded={
                      gameType && gameType === 'mini_crossword'
                        ? ['sudoku', 'crossword']
                        : ['sudoku', 'mini_crossword']
                    }
                    forceLoadDataOnInit
                    isCogratulationsPage
                    cardProps={{ ga4Category: 'congratulations' }}
                    loaderClass={
                      isMobile
                        ? 'congratulations_mobile'
                        : 'congratulations_desktop'
                    }
                  />
                </div> */}
              </div>
            </div>
          )}
      </div>
    </>
  );
};

CrosswordGame.propTypes = {
  isMobile: PropTypes.bool,
  isPrime: PropTypes.bool,
  isFrmapp: PropTypes.bool,
  puzzleAPI: PropTypes.string,
  isToday: PropTypes.bool,
  type: PropTypes.string,
};

CrosswordGame.defaultProps = {
  isMobile: false,
  isPrime: false,
  isFrmapp: false,
  puzzleAPI: '',
  isToday: false,
  type: 'crossword',
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
  gameApiConfigData: _get(state, 'toigames.gamesconfig.gameCategories', ''),
  stateData: state.toigames && state.toigames.crosswordstate,
  showbudgetLinkIdConfig: _get(state, 'common.siteConfig.budgetLinkGameId', ''),
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadCrosswordStateFetch: params => {
    dispatch(loadCrosswordStateFetch(params));
  },
  loadCrosswordStateSave: params => {
    dispatch(loadCrosswordStateSave(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CrosswordGame);
